import _ from 'lodash'
import NetworkMessage from './NetworkMessage'

class Network {
    defaults() {
        return {
            id: 0,
            mission_id: 0,
            settings: {
                collapsed: false,
                active: false,
                messageComposerCollapsed: true,
            },
            initialLoad: false,
            networkMessages: [],
            unreadMessagesCount: 0,
        }
    }

    isStale() {
        const backhaulerIsStale = this.backhaulerLocation && this.backhaulerLocation.isStale()
        if (!backhaulerIsStale) {
            return false
        }

        const time = window.moment().local().unix()
        for (let i = 0; i < this.nodes.length; i++) {
            const lastNodeUpdate = window.moment.utc(this.nodes[i].updated_at).local().unix()
            const staleTimeout = 60 * 5
            if (time - lastNodeUpdate > staleTimeout) {
                return true
            }
        }
        return false
    }

    getName() {
        const name = this.backhauler_callsign ? this.backhauler_callsign : this.backhauler.name
        return `${name}'s Network`
    }

    getNodes() {
        return _.sortBy(this.nodes, [(node) => node.gid !== this.backhauler.gid, (node) => node.callsign])
    }

    getNodeCount() {
        return this.nodes.length
    }

    updateMessages(newMessages) {
        const networkMessages = this.get('networkMessages')
        const timestampNotUpdated = (existingNetworkMessage) => {
            return existingNetworkMessage !== -1 && !networkMessages[existingNetworkMessage].timestamp
        }
        _.forEach(newMessages, (incomingMessage) => {
            const existingNetworkMessage = _.findIndex(
                networkMessages,
                (networkMessage) => networkMessage.id === incomingMessage.id
            )
            let networkMessage
            if (existingNetworkMessage === -1) {
                networkMessage = new NetworkMessage(incomingMessage)
                this.updateUnreadMessagesCount(1)
                networkMessages.push(networkMessage)
            } else if (timestampNotUpdated(existingNetworkMessage)) {
                networkMessage = networkMessages[existingNetworkMessage]
                networkMessage.set(incomingMessage)
            }
        })
    }

    addNewMessage(data) {
        const networkMessages = this.get('networkMessages')
        const networkMessage = new NetworkMessage(data.message)
        networkMessage.markAsRead()
        networkMessages.push(networkMessage)
    }

    getMessages() {
        return _.sortBy(this.get('networkMessages'), [(message) => message.timestamp])
    }

    markMessagesAsRead() {
        const networkMessages = this.get('networkMessages')
        this.set('unreadMessagesCount', 0)
        _.forEach(networkMessages, (nm) => {
            nm.markAsRead()
        })
    }

    updateUnreadMessagesCount(value) {
        const unreadMessagesCount = this.get('unreadMessagesCount')
        this.set('unreadMessagesCount', unreadMessagesCount + value)
    }

    clearUnreadMessages() {
        setTimeout(() => {
            this.markMessagesAsRead()
        }, 5000)
    }

    hasUnreadMessages() {
        const unreadMessagesCount = this.get('unreadMessagesCount')
        return unreadMessagesCount > 0
    }

    getSetting(property) {
        return this.get('settings')[property]
    }

    updateSetting(property, value) {
        this.settings[property] = value
    }

    isCollapsed() {
        return this.getSetting('collapsed')
    }

    setCollapsed(value) {
        this.updateSetting('collapsed', value)
    }

    isMessageComposerCollapsed() {
        return this.getSetting('messageComposerCollapsed')
    }

    setMessageComposerCollapsed(value) {
        this.updateSetting('messageComposerCollapsed', value)
    }

    isActive() {
        return this.getSetting('active')
    }

    setActive(value) {
        this.updateSetting('active', value)
        if (!this.initialLoad) {
            this.set('initialLoad', true)
        }
    }
}

export default Network
